import React, { useEffect, useState } from "react";
import AdminNavbar from "../../components/partial/AdminNavbar";
import { useDispatch, useSelector } from "react-redux";
import { deleteContactData, getContactData } from "../../store/contact/reducer";
import { MdDeleteOutline } from "react-icons/md";
import EmailButton from "../../components/common/EmailButton";
// Helper function to format the date (without time)
const formatDate = (date) => {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(date).toLocaleDateString("en-US", options);
};

// Helper function to get the month and year as a string (e.g., "November 2024")
const getMonthYear = (date) => {
  const options = { year: "numeric", month: "long" };
  return new Date(date).toLocaleDateString("en-US", options);
};

const Contact = () => {
  const dispatch = useDispatch();

  const data = useSelector((state) => state.contactReducer.contactData) || [];
  const contactSlice = useSelector((state) => state.contactReducer);
  console.log("[Contact] contactReducer slice:", contactSlice);
  console.log("[Contact] data used in component:", data);
  const [showModal, setShowModal] = useState(false);
  const [currentContact, setCurrentContact] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  // Manually define month names
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Group the contacts by month and year
  const groupContactsByDate = () => {
    const grouped = data.reduce((acc, contact) => {
      const monthYear = getMonthYear(contact.createdAt);
      if (!acc[monthYear]) {
        acc[monthYear] = [];
      }
      acc[monthYear].push(contact);
      return acc;
    }, {});

    return grouped;
  };

  const contactsByMonthYear = groupContactsByDate(data);

  // Open modal with contact details
  const openModal = (contact) => {
    setCurrentContact(contact);
    setShowModal(true);
  };

  // Close the modal
  const closeModal = () => {
    setCurrentContact(null);
    setShowModal(false);
  };

  useEffect(() => {
    getContactData(dispatch);
  }, [dispatch]);

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this contact?")) {
      dispatch(deleteContactData(id)).then(() => {
        dispatch(getContactData);
        setShowModal(false);
      });
    }
  };

  const groupedContacts = groupContactsByDate();

  // Prevent from displaying same mnth  added
  const getUniqueMonthsAndYears = (data) => {
    const months = new Set();
    const years = new Set();

    data.forEach((contact) => {
      const date = new Date(contact.createdAt);
      const year = date.getFullYear();
      const month = date.toLocaleString("default", { month: "long" });

      months.add(month);
      years.add(year);
    });

    return {
      months: Array.from(months),
      years: Array.from(years),
    };
  };

  const { months, years } = getUniqueMonthsAndYears(data);

  const filteredContacts = Object.keys(contactsByMonthYear).filter(
    (monthYear) => {
      const [month, year] = monthYear.split(" ");
      const monthMatches = selectedMonth ? month === selectedMonth : true;
      const yearMatches = selectedYear ? year === selectedYear : true;
      return monthMatches && yearMatches;
    },
  );

  const filteredGroupContacts = filteredContacts.reduce((acc, monthYear) => {
    acc[monthYear] = contactsByMonthYear[monthYear];
    return acc;
  }, {});

  return (
    <div className="flex flex-col md:flex-row md:items-center bg-gray-100 min-h-screen">
      {/* Sidebar */}
      <div className="lg:w-1/4 bg-white shadow-md">
        <AdminNavbar />
      </div>

      {/* Main Content */}
      <div className="flex-1 p-6 md:flex-row">
        <h2 className="text-3xl font-semibold mb-4 text-center md:text-left">
          Admin Contact Page
        </h2>

        {/* List of Contact Requests */}
        <div className="shadow-md p-4 bg-gray-50 rounded-lg">
          <h3 className="text-2xl font-semibold mb-4 text-center">
            Submitted Contacts
          </h3>

          {/* Date Selection */}
          <div className="flex justify-center items-center mb-4 ">
            {/* Year */}
            <div className="mx-4 text-md rounded-lg border-2 border-[#1e81b0]  ">
              <select
                className="rounded-lg p-2 font-semibold"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                <option value="">Select Year</option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            {/* Month */}
            <div className="mx-4 text-md rounded-lg border-2 border-[#1e81b0]  ">
              <select
                className="rounded-lg p-2 font-semibold"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              >
                <option value="">Select Month</option>
                {monthNames.map((month) => (
                  <option key={month} value={month}>
                    {month}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Loop through grouped contacts by month-year */}
          {Object.keys(filteredGroupContacts).length > 0 ? (
            Object.keys(filteredGroupContacts).map((monthYear) => (
              <div key={monthYear}>
                {/* Month-Year Header */}
                <h4 className="text-xl  font-semibold mt-4  pl-4">
                  {monthYear}
                </h4>

                {/* List of Contacts for the Current Month-Year */}
                <ul className="space-y-3 p-4">
                  {groupedContacts[monthYear].map((contact) => (
                    <li
                      key={contact._id}
                      className="text-lg font-medium cursor-pointer p-4 border hover:bg-gray-200 rounded-lg"
                      onClick={(e) => {
                        if (
                          !e.target.closest(".email-button, .delete-button")
                        ) {
                          openModal(contact);
                        }
                      }}
                    >
                      <div className="flex justify-between items-center">
                        <span>{contact.name}</span>
                        {/* Display the submission date */}
                        <span className="text-sm text-gray-500">
                          {formatDate(contact.createdAt)}
                        </span>

                        {/*Delete Button */}

                        <button
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent triggering modal
                            handleDelete(contact._id);
                          }}
                          className="delete-button mt-2 text-sm bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 flex items-center"
                        >
                          <MdDeleteOutline className="mr-2" />
                          Delete
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ))
          ) : (
            <p className="text-lg text-gray-500">
              No contact requests available.
            </p>
          )}
        </div>
      </div>

      {/* Modal to display full contact details */}
      {showModal && currentContact && (
        <div
          onClick={closeModal}
          className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-10"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white text-black p-8 rounded-lg w-auto m-2 max-h-[80vh] overflow-y-auto relative"
          >
            {/* Close X button inside the modal */}
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-3xl font-semibold text-black hover:text-gray-500 z-20"
            >
              &times;
            </button>

            <h3 className="text-2xl font-semibold mb-4">Contact Details</h3>

            {/* Display Contact Details */}
            <div className="mb-4">
              <strong>Name: </strong>
              {currentContact.name}
            </div>

            <div className="mb-4">
              <strong>Subject: </strong>
              {currentContact.subject}
            </div>

            <div className="mb-4">
              <strong>Email: </strong>
              {currentContact.email}
            </div>

            <div className="mb-4">
              <strong>Message: </strong>
              {currentContact.message}
            </div>

            {/* Date of Submission */}
            <div className="mb-4">
              <strong>Date Submitted: </strong>
              {formatDate(currentContact.createdAt)}
            </div>

            <div className="flex items-center justify-end">
              <EmailButton
                className="text-end"
                recipientEmail={currentContact.email}
                recipientSubject={currentContact.subject}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;
